module.exports = __webpack_public_path__ + "img/Ripple-200px.fc4a19d1.gif";